import { AlertProps, Alert as AntdAlert } from 'antd/lib'
import styles from './Alert.module.less'

export const Alert = (props: AlertProps) => {
    return (
        <div className={styles['alert-container']}>
            <AntdAlert className={styles['alert']} {...props} />
        </div>
    )
}
